
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.961 2.095a2.883 2.883 0 113.25 4.655 4.483 4.483 0 013.272 4.317v1.6a.75.75 0 01-.75.75h-.921l-.466 4.658a.75.75 0 01-.746.675H8.4a.75.75 0 01-.746-.675l-.466-4.658h-.921a.75.75 0 01-.75-.75v-1.6A4.483 4.483 0 018.789 6.75a2.883 2.883 0 01-.828-4.655zM10 2.75a1.383 1.383 0 100 2.767 1.383 1.383 0 000-2.767zm-5.333.633a2.35 2.35 0 00-1.075 4.44 3.416 3.416 0 00-2.342 3.244v1.6c0 .414.336.75.75.75h.405l.45 3.61a.75.75 0 00.745.656h2.133a.75.75 0 000-1.5h-1.47l-.452-3.61a.75.75 0 00-.744-.656H2.75v-.85A1.917 1.917 0 014.667 9.15a.75.75 0 00.632-1.153 2.35 2.35 0 00-.632-4.614zm-.601 1.75a.85.85 0 111.202 1.201.85.85 0 01-1.202-1.202zm9.606-1.061a2.35 2.35 0 112.736 3.751 3.416 3.416 0 012.342 3.244v1.6a.75.75 0 01-.75.75h-.405l-.45 3.61a.75.75 0 01-.745.656h-2.133a.75.75 0 110-1.5h1.47l.452-3.61a.75.75 0 01.744-.656h.317v-.85a1.917 1.917 0 00-1.917-1.917.75.75 0 01-.632-1.153 2.35 2.35 0 01-1.03-3.925zm1.662.811a.85.85 0 100 1.7.85.85 0 000-1.7zM7.89 8.957a2.983 2.983 0 015.093 2.11v.85h-.85a.75.75 0 00-.746.675l-.466 4.658H9.08l-.466-4.658a.75.75 0 00-.746-.675h-.85v-.85c0-.792.314-1.55.873-2.11z"}})])
          )
        }
      }
    